import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import classes from "./Layout.module.css";
import SideBar from "../../components/SiderBar/SideBar";
import useWindowDimensions from "../../hooks/getWindowDimensions";
import Users from "../Users/Users";
import Financial from "../Financial/Financial";
import Risk from "../Risk/Risk";
import Pool from "../Pool/Pool";
import PastRequests from "../Financial/PastRequests/PastRequests";
import { useAuth } from "../../context/AuthContext";
import Referrals from "../Referrals/Referrals";

const Layout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showLogoutCard, setShowLogoutCard] = useState(false);
  const { height, width } = useWindowDimensions();
  const { logout } = useAuth();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const toggleLogoutCard = () => {
    setShowLogoutCard((prev) => !prev);
  };

  return (
    <div className={`${classes.main} d-flex`}>
      <SideBar />
      <div className={classes.content}>
        <div className="d-flex align-items-center justify-content-end">
          <div>
            <div
              className={classes.avatarContianer}
              onClick={toggleLogoutCard}
              role="button"
            ></div>
            {showLogoutCard && <div className={classes.logoutCard} onClick={logout} role="button">
              Logout
            </div>}
          </div>
        </div>
        <Routes>
          <Route path="/" element={<Navigate to="/users" />} />
          <Route path="/users" element={<Users />} />
          <Route path="/financial" element={<Financial />} />
          <Route path="/financial/past-requests" element={<PastRequests />} />
          <Route path="/risk" element={<Risk />} />
          <Route path="/pool" element={<Pool />} />
          <Route path="/referrals" element={<Referrals />} />
          {/* <Route path="/profile" element={<Profile />} /> */}
        </Routes>
        {/* {width > 998 && <div className={`${classes.footerWrapper} d-flex align-items-center justify-content-between`}>
          <div className={classes.termsContainer}><a href="#"  target="_blank">Privacy Policy</a> · <a href="https://wb-trading-site.vercel.app/terms" target="_blank">Terms of Service</a></div>
          <div className={`d-flex align-items-center gap-3 ${classes.socialContainer}`}><XIcon /><DiscordIcon /><FacebookIcon /><YouTubeIcon /><InstagramIcon /></div>
        </div>} */}
      </div>
      {/* {width <= 998 && <BottomBar />} */}
    </div>
  );
};

export default Layout;
